
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1040_1986)","fill":"#fff"}},[_c('path',{attrs:{"d":"M5.25 1.05C5.25.47 4.78 0 4.2 0H3.15A3.15 3.15 0 000 3.15V4.2a1.05 1.05 0 002.1 0V3.15c0-.58.47-1.05 1.05-1.05H4.2c.58 0 1.05-.47 1.05-1.05zM15.75 1.05c0-.58.47-1.05 1.05-1.05h1.05A3.15 3.15 0 0121 3.15V4.2a1.05 1.05 0 11-2.1 0V3.15c0-.58-.47-1.05-1.05-1.05H16.8c-.58 0-1.05-.47-1.05-1.05zM4.2 21a1.05 1.05 0 100-2.1H3.15c-.58 0-1.05-.47-1.05-1.05V16.8a1.05 1.05 0 10-2.1 0v1.05A3.15 3.15 0 003.15 21H4.2zM15.75 19.95c0 .58.47 1.05 1.05 1.05h1.05A3.15 3.15 0 0021 17.85V16.8a1.05 1.05 0 10-2.1 0v1.05c0 .58-.47 1.05-1.05 1.05H16.8c-.58 0-1.05.47-1.05 1.05zM13.65 7.35c0 .976-.444 1.849-1.142 2.427a3.137 3.137 0 01-2.008.723c-.761 0-1.459-.27-2.004-.72l-.004-.003A3.15 3.15 0 1113.65 7.35z"}}),_c('path',{attrs:{"d":"M7.45 10.237A6.298 6.298 0 004.2 15.75v.56c0 .27.22.49.49.49h11.62c.27 0 .49-.22.49-.49v-.56a6.298 6.298 0 00-3.25-5.513 4.188 4.188 0 01-3.05 1.313 4.188 4.188 0 01-3.05-1.313z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1040_1986"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h21v21H0z"}})])])])
          )
        }
      }
    